import { CardF } from '@atmi/models/cards/card-f';
import { createStore } from '@ngneat/elf';
import {
  addEntities,
  deleteEntities,
  selectAllEntities,
  setEntities,
  updateEntities,
  withEntities
} from '@ngneat/elf-entities';

export const store = createStore({ name: 'beneF' }, withEntities<CardF>());

export const beneF$ = store.pipe(selectAllEntities());

export function setAllF(cards: CardF[]) {
  store.update(setEntities(cards));
}

export function addF(card: CardF) {
  store.update(addEntities(card));
}

export function updateF(id: CardF['id'], card: Partial<CardF>) {
  store.update(updateEntities(id, card));
}

export function deleteF(id: CardF['id']) {
  store.update(deleteEntities(id));
}

